export enum ABOUT_US_TABS {
    TEAM = 'Unser Team',
    JOBS = 'Stellenangebote',
}
